import { createRemoveSyncSlice } from '@sonar-software/xuder';
import { getAdminFeatureFlagsSlice } from './get';
import { PostOverrideAdminFeatureFlagByCustomerIdRequest } from '../../api';
import { UseDefaultAdminFeatureFlagName } from './_id/customer/name';

export const removeAdminFeatureFlagCustomerSlice = createRemoveSyncSlice({
	name: UseDefaultAdminFeatureFlagName,
	state: getAdminFeatureFlagsSlice.asyncState,
	transform: (action: PostOverrideAdminFeatureFlagByCustomerIdRequest, state) => ({
		featureFlags: state?.featureFlags?.map((flag) => {
			if (flag.name === action.featureFlag) {
				return {
					...flag,
					exceptionCustomers: flag.exceptionCustomers.filter((customer) => customer.id !== action.customerId)
				};
			}

			return flag;
		}) ?? [],
		totalCustomerCount: state?.totalCustomerCount ?? 0
	})
});
